const setElementProps = void 0;
export { setElementProps };